import { render, staticRenderFns } from "./FilterThird.vue?vue&type=template&id=b3a05c6a&scoped=true"
import script from "./FilterThird.vue?vue&type=script&lang=js"
export * from "./FilterThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a05c6a",
  null
  
)

export default component.exports